// tslint:disable-next-line:max-file-line-count
import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
const includes = require('lodash.includes');

import { setCookie } from '@cian/utils/lib/browser/cookie';

import { FiltersBlock } from '../../components/filters_block/filters_block';
import { SearchFilters } from '../../components/search_filters/search_filters';
import { BuildingTypeFilter } from '../../containers/filters/building_type_filter';
import { TypeFilter } from '../../containers/filters/type_filter';
import { getFiltersConfiguration } from '../../helpers/ab_mainpage_newbuilding_search';
import {
  AB_NEWBUILDING_SEARCH_TABS_EXPERIMENTS,
  getABNewbuildingSearchTabs,
  getABNewbuildingSearchTabsBucket,
  parseParamsToNewbuildingUrl,
} from '../../helpers/ab_newbuilding_search_tabs';
import * as Analytics from '../../helpers/analytics_helper';
import { declineNumeric, formatPrice } from '../../helpers/format_helper';
import { IBedroom } from '../../models/filters/bedroom';
import { IBuildingTypes, IBuildingTypesConfig } from '../../models/filters/building_types';
import { ISearchPrice } from '../../models/filters/price';
import { IRooms } from '../../models/filters/rooms';
import { ISquare } from '../../models/filters/square';
import { ISuburbanOfferFilter } from '../../models/filters/suburban_offer_filter';
import { ISearchType } from '../../models/filters/type';
import { IUserGeo } from '../../models/filters/user_geo';
import { IYear } from '../../models/filters/year';
import { IHousingInfo } from '../../models/housing_info';
import { IRegionsData } from '../../models/regions_data';
import { ISearchConfig } from '../../models/search';
import { IStore } from '../../models/store';
import { IUser } from '../../models/user';
import { IDomain } from '../../redux/modules/domain/domain';
import { getHousingInfo } from '../../redux/modules/housing_info';
import { getMapUrl, getSearchUrl, IJsonQueryTerms } from '../../redux/modules/search/search';
import { matchQueryParams } from './query_params_matcher';
import { renderFilters } from './search_config';

interface IProps {
  abGroup: number;
  dispatch?: Dispatch<any>;
  housingInfo: IHousingInfo;
  type: ISearchType;
  buildingType: IBuildingTypes;
  actualBuildingType: IBuildingTypes;
  square: ISquare;
  subdomain: string;
  rooms: IRooms;
  price: ISearchPrice;
  userGeo: IUserGeo;
  bedroom: IBedroom;
  year: IYear;
  regionsData: IRegionsData;
  domain: IDomain;
  section: string;
  title: string;
  user: IUser;
  searchConfig: ISearchConfig;
  buildingTypes: IBuildingTypesConfig;
  suburbanOfferFilter: ISuburbanOfferFilter;
  isExperimentsLoading: boolean;
  abNewbuildingSearchTabs: boolean;
  abNewbuildingSearchTabsBucket: AB_NEWBUILDING_SEARCH_TABS_EXPERIMENTS | undefined;
}

interface IState {
  isApartment?: boolean;
  backgroundImageUrl?: string;
  backgroundShown: boolean;
  mediaNote?: string;
}

interface IFilterProps {
  section: string;
}

interface ISearchUrl {
  searchUrl: string;
  queryStringOrPathName: string;
}

class FiltersComponent extends React.Component<IProps, IState> {
  private timer: NodeJS.Timer |number;

  public constructor(props: IProps) {
    super(props);
    this.onLoadAdfox = this.onLoadAdfox.bind(this);
    this.state = {
      backgroundShown: false,
    };
  }

  public componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({
        backgroundImageUrl: undefined,
        backgroundShown: true,
        isApartment: false,
      });
    }, 2000);
  }

  public submitSearch() {
    if (!this.props.dispatch) {
      return;
    }

    const params = matchQueryParams(
      this.props.type,
      this.props.actualBuildingType,
      this.props.square,
      this.props.rooms,
      this.props.price,
      this.props.userGeo,
      this.props.bedroom,
      this.props.year,
      (this.props.section === 'new-buildings'),
      this.props.suburbanOfferFilter,
    );

    const topRegions = [1, 2, 4593, 4588, -1, -2];
    (this.props.dispatch(getSearchUrl(params)) as any)
      .then((url: ISearchUrl) => {
        const {
          actualBuildingType: { buildingType },
          rooms: { rooms },
          price,
          userGeo,
          abNewbuildingSearchTabsBucket,
        } = this.props;
        let searchUrl = url.searchUrl;

        if (
          (params.region && includes(topRegions,
          (params.region as IJsonQueryTerms<number>).value[0])) ||
          (this.props.section === 'new-buildings')
        ) {
          searchUrl = this.replaceSearchPath(params._type, searchUrl);
        }

        if (
          buildingType.includes('new_flat')
          && abNewbuildingSearchTabsBucket === AB_NEWBUILDING_SEARCH_TABS_EXPERIMENTS.C
        ) {
          let host = url.searchUrl.split(url.queryStringOrPathName)[0];
          const query = parseParamsToNewbuildingUrl(rooms, price, userGeo);
          let baseQuery = query ?
            '/newobjects/list/?deal_type=sale&engine_version=2&offer_type=newobject'
            : '/novostroyki';

          searchUrl = `${host}${baseQuery}${query && '&'}${query}`;
        }

        Analytics.trackSearchEvent(
          'button_search',
          this.props.section,
          url.queryStringOrPathName,
          params,
          this.props.user,
          this.props.abGroup,
        );

        /**
         * Ставим сессионую гео-куку на основе полученных данных от гео фильтра
         */
        const { regionId, mainTownId } = this.props.userGeo.userGeoDefinitionWithGeoFilter;

        if (regionId) {
          setCookie('session_region_id', String(regionId), { secure: false });
        }

        if (mainTownId) {
          setCookie('session_main_town_region_id', String(mainTownId), { secure: false });
        }

        window.location.href = searchUrl;
      });
  }

  public submitMapSearch() {
    if (!this.props.dispatch) {
      return;
    }

    const params = matchQueryParams(
      this.props.type,
      this.props.actualBuildingType,
      this.props.square,
      this.props.rooms,
      this.props.price,
      this.props.userGeo,
      this.props.bedroom,
      this.props.year,
      (this.props.section === 'new-buildings'),
      this.props.suburbanOfferFilter,
    );

    (this.props.dispatch(getMapUrl(params)) as any)
      .then((url: string) => {
        Analytics.trackSearchEvent(
          'search_on_map',
          this.props.section,
          url,
          params,
          this.props.user,
          this.props.abGroup,
        );

        Analytics.clickSearchOnMapButtonOnFilter(this.props.section, url);

        window.location.href = url;
      });
  }

  public render() {
    let mediaInfoText: string | undefined;
    const hi = this.props.housingInfo;
    if (hi.offers_count) {
      mediaInfoText = `В продаже ${formatPrice(hi.offers_count)}
     ${declineNumeric(hi.offers_count, (this.state.isApartment
        ? ['апартамент', 'апартамента', 'апартаментов']
        : ['квартира', 'квартиры', 'квартир']))} по цене от ${formatPrice(hi.min_price2)} ₽`;
    }

    return (
      <FiltersBlock
        section={this.props.section}
        backgroundShown={this.state.backgroundShown}
        mediaInfoText={mediaInfoText}
        backgroundImageUrl={this.state.backgroundImageUrl}
        mediaNote={this.state.mediaNote}
        onLoadAdfox={this.onLoadAdfox}
        isExperimentsLoading={this.props.isExperimentsLoading}
        abNewbuildingSearchTabs={this.props.abNewbuildingSearchTabs}
        selectedType={this.props.type.searchType}
      >
        <SearchFilters
          title={this.props.title}
          onSubmit={() => this.submitSearch()}
          onMapSubmit={() => this.submitMapSearch()}>
          {
            (this.props.section !== 'new-buildings') &&
            <TypeFilter
              buildingTypes={this.props.buildingTypes}
              searchConfig={this.props.searchConfig}
            />
          }
          {
            (this.props.section !== 'new-buildings') &&
            <BuildingTypeFilter
              buildingType={this.props.buildingType.buildingType}
              buildingTypes={this.props.buildingTypes}
              searchConfig={this.props.searchConfig}
            />
          }
          { renderFilters(
            this.props.type.searchType,
            this.props.buildingType.buildingType,
            (this.props.section === 'new-buildings'),
            this.props.searchConfig,
          )
          }
        </SearchFilters>
      </FiltersBlock>
    );
  }

  private onLoadAdfox(context: {newBuildingId: string, isApartment: string, bgImageUrl: string, note: string}) {
    if (this.props.dispatch) {
      if (!this.props.housingInfo.isFetching) {
        this.props.dispatch(getHousingInfo(void 0, context.newBuildingId));
      }
      clearTimeout(this.timer as number);
      this.setState({
        backgroundImageUrl: context.bgImageUrl,
        backgroundShown: true,
        isApartment: !!+context.isApartment,
        mediaNote: context.note,
      });
    }
  }

  private replaceSearchPath(type: string, url: string) {
    const searchUrlRe =
      (this.props.section === 'new-buildings')
        ? /\/newobjects\/list\//
        : /\/cat\.php/;
    const filtersFormUrl =
      (this.props.section === 'new-buildings')
        ? '/newobjects/search/'
        : '/nd/search/';

    return url.replace(searchUrlRe, filtersFormUrl);
  }
}

export const Filters = connect((state: IStore, props: IFilterProps): IProps => {
  const { section } = props;
  const filtersConfiguration = getFiltersConfiguration(state, section);

  return {
    ...filtersConfiguration,
    abGroup: state.config.abGroup,
    bedroom: state.bedroom,
    domain: state.domain,
    housingInfo: state.housingInfo,
    isExperimentsLoading: state.mainpage.experiments === undefined,
    price: state.price,
    regionsData: state.mainpage.regionsData,
    rooms: state.rooms,
    section,
    square: state.square,
    subdomain: state.config.subdomain,
    title: state.mainpage.seoData.h1,
    type: state.type,
    user: state.user,
    userGeo: state.userGeo,
    year: state.year,
    suburbanOfferFilter: state.suburbanOfferFilter,
    abNewbuildingSearchTabs: getABNewbuildingSearchTabs(state.mainpage),
    abNewbuildingSearchTabsBucket: getABNewbuildingSearchTabsBucket(state.mainpage),
  };
})(FiltersComponent);
